<template>
    <div class="login">
      <h1>Login</h1>
      <form @submit.prevent="submitPhoneNumber">
        <input v-model="mobile" type="text" placeholder="Enter Mobile Number" />
        <button type="submit">Send OTP</button>
      </form>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import api from '@/axios';

  const mobile = ref('');
  const router = useRouter();
  
  const submitPhoneNumber = async () => {
    try {
      // Send the phone number to the backend to generate OTP
      await api.post('/sendotp', { mobile: mobile.value });
      localStorage.setItem('otpMobile', mobile.value);
      // Redirect to OTP verification page
      router.push('/verify-otp');

    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  };
  </script>
  
  <style scoped>
  /* Add your styling here */
  </style>
  